const users = [
  {
    id: '1',
    avatar: 'https://i.pravatar.cc/100',
    name: 'Jorge silva',
    country: 'Chile',
    interests: ['Finanças e Relações com Investidores'],
  },
  {
    id: '2',
    avatar: 'https://i.pravatar.cc/200',
    name: 'Marcos santos',
    country: 'Brasil',
  },
  {
    id: '3',
    avatar: 'https://i.pravatar.cc/500',
    name: 'Alice silveira',
    country: 'Espanha',
  },
  {
    id: '4',
    avatar: 'https://i.pravatar.cc/120',
    name: 'Marcos santos',
    country: 'Brasil',
  },
  {
    id: '5',
    avatar: 'https://i.pravatar.cc/222',
    name: 'Marcos santos',
    country: 'Brasil',
  },
  {
    id: '6',
    avatar: 'https://i.pravatar.cc/133',
    name: 'Marcos santos',
    country: 'Brasil',
  },
];

export default users;
